module.exports = __webpack_public_path__ + "img/logo.d309094e.png";